import { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Location } from 'history'

const historySinceEnter: Location[] = []

const useIsBack = () => {
  const { action } = useHistory()
  const location = useLocation()

  const [isBack, setIsBack] = useState(false)
  const [backFrom, setBackFrom] = useState<Location | null>()

  const lastHistoryIndex = historySinceEnter.length - 1
  const previousLocation = historySinceEnter?.[lastHistoryIndex]
  if (previousLocation?.key !== location.key) {
    let goBack = false
    let goBackFrom = null

    switch (action) {
      case 'PUSH':
        historySinceEnter.push(location)
        break

      case 'POP': {
        // Pop state changes fire for all navigations (back and forwards). We use the saved
        // history state to distinguish between backward and forward navigations.
        const olderLocation = historySinceEnter[lastHistoryIndex - 1]

        if (olderLocation?.key === location.key) {
          goBack = true
          goBackFrom = historySinceEnter.pop()
        } else {
          historySinceEnter.push(location)
        }
        break
      }

      case 'REPLACE':
        historySinceEnter.pop()
        historySinceEnter.push(location)
        break

      default:
        break
    }

    setIsBack(goBack)
    setBackFrom(goBackFrom)
  }

  return {
    isBack: isBack,
    backFrom: backFrom,
    prototypeHistory: historySinceEnter,
  }
}

export default useIsBack
